const ITEMS = [
  "Le seuil entre l’existant et le nouvel intérieur",
  "Isolation",
  "Plaquisterie",
  "Cloisons &amp; doublages",
  "Faux plafonds",
  "Finitions",
  "Aménagement intérieur",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span
          className="whitespace-nowrap px-10 font-heading text-4xl md:text-6xl font-semibold tracking-tight text-nuit/[0.08]"
          dangerouslySetInnerHTML={{ __html: t }}
        />
        <span className="h-1.5 w-1.5 rotate-45 bg-sable/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-b border-mineral bg-casse py-16 lg:py-20">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
